import { render, staticRenderFns } from "./Fifth_mobile.vue?vue&type=template&id=0a001566&scoped=true&"
import script from "./Fifth_mobile.vue?vue&type=script&lang=js&"
export * from "./Fifth_mobile.vue?vue&type=script&lang=js&"
import style0 from "./Fifth_mobile.vue?vue&type=style&index=0&id=0a001566&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a001566",
  null
  
)

export default component.exports